const style1 = {
  backgroundColor: '#4F81BD',
  color: '#fff',
  minWidth: '150px',
};
const style2 = {
  backgroundColor: '#00B050',
  color: '#fff',
};

export const HeaderStandard = [
  [
    { text: 'S.No.', style: style1 },
    { text: 'Check Points', style: style1 },
    { text: 'Specification', style: style1 },
    { text: 'Checking/Maitenance Method', style: style1 },
    { text: 'Status (OK/NG)', style: style1 },
    { text: 'Observations', style: { ...style1, minWidth: '300px' } },
    { text: 'Action Taken', style: style1 },
    { text: 'Remarks', style: style1 },
    { text: 'Action', style: { ...style1, backgroundColor: '#c92a2a' } },
  ],
];

export const listConstant = {
  childHeader: 'Predictive Maintenance Checksheet list',
  addButtonLable: 'New Checksheet',
};

export const headerConstant = {
  tableCompHeadTitle: 'Predictive Maintenance CHECKSHEET ',
};

export const apiConstant = {
  get: 'predictiveMaintenancePlanMasterChecklistRoute',
  getById: 'predictiveMaintenancePlanMasterChecklistRoute',
  post: 'predictiveMaintenancePlanMasterChecklistRoute',
  update: 'predictiveMaintenancePlanMasterChecklistRoute',
  delete: 'predictiveMaintenancePlanMasterChecklistRoute',
  upload: 'predictiveMaintenancePlanMasterChecklistRoute/uploadFile',
  forAutoComplete: 'machineRoutes/machine/ForAutocomplete',
};

export const tilesConstant = {
  childHeaderText: 'Predictive Maintenance',
};

export const navigationConstant = {
  createEditChecklist: '/admin/predictiveMaintenancePlanMasterChecklistCreate',
};
